import { DEFAULT_OPACITY } from '../definitions/defaultOpacities';

const opacity = {
  0: DEFAULT_OPACITY[0],

  25: DEFAULT_OPACITY[2],

  50: DEFAULT_OPACITY[4],

  65: DEFAULT_OPACITY[5],

  80: DEFAULT_OPACITY[7],

  100: DEFAULT_OPACITY[9],
};

export { opacity };
